import { render, staticRenderFns } from "./hex-mesh.vue?vue&type=template&id=35bba32b&"
import script from "./hex-mesh.vue?vue&type=script&lang=js&"
export * from "./hex-mesh.vue?vue&type=script&lang=js&"
import style0 from "./hex-mesh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports